<template>
  <img
    v-if="isCustom && customSrc"
    :src="customSrc"
    :alt="alt"
    :title="title || null"
    :aria-hidden="computedAriaHidden"
    :style="sizeStyle"
    v-bind="$attrs"
  />
  <UIcon
    v-else
    :name="resolvedName"
    :mode="mode"
    :size="size"
    :title="title || null"
    :aria-hidden="computedAriaHidden"
    v-bind="$attrs"
  />
</template>

<script setup>
import { computed } from 'vue'
import { customIcons } from '~/components/icons/custom'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  size: {
    type: [Number, String],
    default: null,
  },
  mode: {
    type: String,
    default: undefined,
  },
  width: {
    type: [Number, String],
    default: null,
  },
  height: {
    type: [Number, String],
    default: null,
  },
  ariaHidden: {
    type: [Boolean, String],
    default: undefined,
  },
})

const isCustom = computed(() => props.name.startsWith('custom:'))

const resolvedName = computed(() => {
  if (props.name.startsWith('lucide:')) {
    return `i-lucide-${props.name.slice('lucide:'.length)}`
  }
  return props.name
})

const customKey = computed(() =>
  props.name.startsWith('custom:') ? props.name.slice('custom:'.length) : null
)

const customSrc = computed(() =>
  customKey.value ? customIcons[customKey.value] : null
)

const computedAriaHidden = computed(() => {
  if (props.ariaHidden !== undefined) {
    if (typeof props.ariaHidden === 'string') return props.ariaHidden === 'true'
    return props.ariaHidden
  }
  return !props.alt && !props.title
})

const sizeStyle = computed(() => {
  const width = props.width ?? props.size
  const height = props.height ?? props.size
  if (!width && !height) return null
  const toCss = (value) => (typeof value === 'number' ? `${value}px` : value)
  return {
    width: width ? toCss(width) : undefined,
    height: height ? toCss(height) : undefined,
  }
})
</script>
